import {Injectable} from '@angular/core';
import {NavService} from './nav-service';
import {Router} from '@angular/router';
import {AppPath} from '../../app-path';
import {LoginNavigator} from './navigators/login-navigator';

@Injectable({
  providedIn: 'root',
})
export class RootNavService extends NavService {
  constructor(router: Router) {
    super(router);
  }

  accueil = this.makeNavigator(AppPath.ACCUEIL);

  profils_droits = this.makeNavigator(AppPath.PROFILS_DROITS);

  login = new LoginNavigator(this.router);

  non_autorise = this.makeNavigator(AppPath.NON_AUTORISE);

  formateurs = this.makeNavigator(AppPath.FORMATEURS);

  personnes = this.makeNavigator(AppPath.PERSONNES);

  utilisateurs = this.makeNavigator(AppPath.UTILISATEURS);
}
